import { useFormik } from "formik";
import { useEffect } from "react";
import toast from "react-hot-toast";
import Select from 'react-select';
import { Button, Form, FormGroup, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { InputField } from "src/components";
import { useCreateLookupChildMutation } from "src/rtk/features/setup/lookup/lookupChildApi";
import { useCreateLookupInfoMutation, useGetLookupInfosQuery } from "src/rtk/features/setup/lookup/lookupInfoApi";
import * as Yup from 'yup';

const initialValues: LookupChild = {
  setup_lookup_info_id: '',
  lookup_list_name: '',
  parent_lookuplist_id: '',
  status: true,
  serial_no: '',
};

const AddChildLookup = (props: any) => {
  const { isOpen, toggle, infoId } = props;

  const { data: lookupInfo } = useGetLookupInfosQuery();

  const options: { value: string; label: string }[] = [];

  lookupInfo?.data?.map((lookup) => {
    options.push({ value: lookup.id!, label: lookup.lookup_name });
  });
  const [createLookupChild, { isSuccess, isError, error }] = useCreateLookupChildMutation();

  const formik = useFormik({
    initialValues,
    validationSchema: Yup.object({
      lookup_list_name: Yup.string().required('Lookup Code is required'),
    }),
    onSubmit: (values) => {
      // Handle form submission logic here
      console.log('Form submitted:', values);
      createLookupChild(values);
    },
  });
  const { handleChange, handleSubmit, getFieldProps, values, errors, touched, resetForm, setFieldValue } = formik;

  useEffect(() => {
    if (isSuccess) {
      resetForm();
      toast.success('Lookup created successfully');
      toggle();
    }
    if (isError) {
      toast.error('Error creating lookup');
    }
  }, [isSuccess, isError]);

  useEffect(() => {
    if (infoId) {
      setFieldValue('setup_lookup_info_id', infoId);
    }
  }, [infoId]);

  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>Edit Data</ModalHeader>
      <Form
        onSubmit={(e) => {
          e.preventDefault();
          handleSubmit(e);
        }}
      >
        <ModalBody>
          <div>
            <FormGroup className="mb-3">
              <Label for="setup_lookup_info_id">Lookup Info ID</Label>
              <Select
                isSearchable={true}
                options={options}
                name="setup_lookup_info_id"
                value={options.find(
                  (option) => option.value === values.setup_lookup_info_id,
                )}
                isDisabled={true}
              />
            </FormGroup>

            <FormGroup className="mb-3">
              <Label for="lookup_list_name">Lookup List Name</Label>
              <InputField
                type="text"
                placeholder="Lookup List Name"
                {...getFieldProps('lookup_list_name')}
              />
            </FormGroup>
            <FormGroup className="mb-3">
              <Label for="serial_no">Serial No</Label>
              <InputField
                type="number"
                placeholder="Serial No"
                {...getFieldProps('serial_no')}
              />
            </FormGroup>

            <FormGroup className="mb-3">
              <Label for="parent_lookuplist_id">Parent Lookup List</Label>
              <Select
                isSearchable={true}
                options={options}
                name="parent_lookuplist_id"
                onChange={(e: { label: any; value: any }) => {
                  setFieldValue('parent_lookuplist_id', e?.value || '');
                }}
                value={options.find(
                  (option) => option.value === values.parent_lookuplist_id,
                )}
              />
            </FormGroup>
            <FormGroup switch className="mb-3">
              <Input
                type="switch"
                role="switch"
                placeholder="Status"
                {...getFieldProps('status')}
              />
              <Label for="status">Active Status</Label>
            </FormGroup>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button type="submit" color="primary">
            Save
          </Button>{' '}
          <Button color="secondary" onClick={toggle}>
            Cancel
          </Button>
        </ModalFooter>
      </Form>
    </Modal>
  )
}

export default AddChildLookup;